const { config, remoteRest, remoteGenieRest } = window.__env;

export const api: Readonly<any> = {
    host: remoteRest.host,
    restServiceUrl: `${remoteRest.protocol}://${remoteRest.host}:${remoteRest.port}/${remoteRest.route}`,
    restGenieServiceUrl: `${remoteGenieRest.protocol}://${remoteGenieRest.host}:${remoteGenieRest.port}/${remoteGenieRest.route}`,
    restServiceUrlDB: `${remoteRest.protocol}://${remoteRest.host}:${remoteRest.port}/${remoteRest.route}`,
    version: config ? config.versionRM : ''
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/constants/api.ts